import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateVariantMaskInput,
    DeleteVariantMaskInput,
    UpdateVariantMaskInput,
    VariantMask
} from '../../services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class VariantMaskService {
    private amplifyClient = generateClient();
    constructor() {}

    async listVariantMasks(): Promise<VariantMask[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listVariantMasks
                })
            ).data.listVariantMasks.items;
            if (data) return data as VariantMask[];
        } catch (error) {
            console.error('Error finding VariantMask:', error);
            return null;
        }
    }

    async listVariantMasksByMaskId(
        productMaskId: string
    ): Promise<VariantMask[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.VariantMasksByProductMaskId,
                    variables: {
                        productMaskId
                    }
                })
            ).data.VariantMasksByProductMaskId.items;
            if (data) return data as VariantMask[];
        } catch (error) {
            console.error('Error finding VariantMask:', error);
            return null;
        }
    }

    async createVariantMask(
        input: CreateVariantMaskInput
    ): Promise<VariantMask> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createVariantMask,
                    variables: {
                        input
                    }
                })
            ).data.createVariantMask;
            if (date) return date as VariantMask;
        } catch (error) {
            console.error('Error creating VariantMask:', error);
            return null;
        }
    }
    async updateVariantMask(
        input: UpdateVariantMaskInput
    ): Promise<VariantMask> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateVariantMask,
                    variables: {
                        input
                    }
                })
            ).data.updateVariantMask;
            if (date) return date as VariantMask;
        } catch (error) {
            console.error('Error creating VariantMask:', error);
            return null;
        }
    }

    async deleteVariantMask(
        input: DeleteVariantMaskInput
    ): Promise<VariantMask> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteVariantMask,
                    variables: {
                        input
                    }
                })
            ).data.deleteVariantMask;
            if (date) return date as VariantMask;
        } catch (error) {
            console.error('Error creating ProductMask:', error);
            return null;
        }
    }
}
